import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  wantToBuyForEdit: {
    id: undefined,
    type: "",
    condition: "",
    hours: "",
    location: null,
    price: "",
    display_name: "",
    createdAt: "",
    enfNumber: "",
    createdBy: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const wantToBuySlice = createSlice({
  name: "wantToBuy",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // location loader
    wantToBuyListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    wantToBuyList: (state, action) => {
      const { result, count } = action.payload;

      let tempArray = [];

      result.forEach(item => {
        let tempObj = {
          id: item.id,
          type: item.type,
          condition: item.condition,
          hours: item.hours,
          location: item.location,
          price: item.price,
          status: item.status,
          name: item.name,
          createdAt: item.createdAt,
          createdBy: item.createdBy,
          enfNumber: item.enfNumber,
        };

        tempArray.push(tempObj);
      });

      state.totalCount = count;
      state.entities = tempArray;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadWantToBuyForEdit: (state, action) => {
      let temp = {
        id: action.payload.id,
        type: action.payload.type,
        condition: action.payload.condition,
        hours: action.payload.hours,
        location: action.payload.location,
        price: action.payload.price,
        status: action.payload.status,
        name: action.payload.name,
        createdAt: action.payload.createdAt,
        enfNumber: action.payload.enfNumber,
        createdBy: action.payload.createdBy,
      };

      state.wantToBuyForEdit = temp;
    },
    loadWantToBuyMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
  },
});
